<template>
	<layout activeLabel="密码管理">
		<div class="card">
			<el-form class="form-card" ref="form" :rules="rules" :model="ruleForm" label-width="140px">
				<el-form-item label="原密码" prop="origin"><el-input v-model="ruleForm.origin" type="password" placeholder="请输入原始密码"></el-input></el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input v-model="ruleForm.password" type="password" show-password placeholder="请输入新密码"></el-input>
					<!-- <p class="warn">*密码需要同同时由字母数字组成</p> -->
				</el-form-item>
				<el-form-item label="确认新密码" prop="rptpassword">
					<el-input v-model="ruleForm.rptpassword" show-password type="password" placeholder="请确认新密码"></el-input>
				</el-form-item>
        <span style="color: red;font-size: 10px;margin-top: 10px;">
              *密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
            </span>
				<el-form-item><el-button class="saveBtn" @click="savePassword('form')">保存</el-button></el-form-item>
			</el-form>
		</div>
	</layout>
</template>

<script>
import layout from './index.vue';
import api from '../../http/electrician/api.js';
export default {
	name: 'leaveMessage',
	components: { layout },
	data() {
		let verify_password = (rule, value, callback) => {
			if (this.ruleForm.password != this.ruleForm.rptpassword) {
				callback(new Error('两次输入的密码不一致'));
			} else {
				callback();
			}
		};
		return {
			ruleForm: {},
			score: 3,
			rules: {
				origin: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
				password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
				rptpassword: [{ required: true, message: '请再次新密码', trigger: 'blur' }, { required: true, trigger: 'blur', validator: verify_password }]
			}
		};
	},
	methods: {
		savePassword(formName) {
			this.$refs[formName].validate(valid => {
				let reg = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/
				if (reg.test(this.ruleForm.password) == false) {
					return this.$message("密码最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符");
				}
				if (valid) {
					api.electrician_info_password({
						pwd: this.ruleForm.origin,
						newPwd: this.ruleForm.password,
						cNewPwd: this.ruleForm.rptpassword
					}).then(res => {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
					});
				}
			});
		}
	}
};
</script>
<style lang="less" scoped>
.card {
	padding-right: 2.5rem;
	padding-top: 0.48rem;
	box-sizing: border-box;
	display: flex;
	.warn {
		font-size: 0.14rem;
		font-weight: 400;
		color: #ff5454;
	}
	.form-card {
		padding: 0 1rem 0.7rem;
		flex: 1;
		.saveBtn {
			width: 1.38rem;
			background: #5c5c5c;
			border-radius: 0.06rem;
			opacity: 1;
			margin-top: 0.4rem;
			font-size: 0.14rem;
			color: #fff;
			padding: 0;
			line-height: 0.2rem;
			padding: 0.12rem 0;
		}
	}
	.newPassword {
		margin-bottom: 5px !important;
	}
	/deep/ .el-form-item__content {
		position: relative;
	}
	/deep/ .el-form-item__label {
		font-size: 0.14rem;
		color: #929292;
		padding-right: 0.34rem;
	}
	/deep/ .el-input__inner {
		background: #f5f5f5;
		font-size: 0.13rem;
		border: unset;
		color: #000;
	}
}
</style>
